import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import { logIn, logOut, onAuthStateChanged, loadBotList, loadMessages, sendResponse } from '@/services/firebase-api';
import { subscribeToNotifications, unsubscribeFromNotifications } from '@/services/messaging';
// import {logIn, logOut, onAuthStateChanged, loadBotList, loadMessages, sendResponse} from '@/services/stub-api';
Vue.use(Vuex);
// function findConversation(conversationId: string, conversations: Conversation[]): Conversation {
//   for (const conversation of conversations) {
//     if (conversation.id === conversationId) {
//       return conversation;
//     }
//   }
const options = {
    state: {
        error: null,
        loading: false,
        bots: null,
        conversations: {},
        openConversations: {}
    },
    // ----- Synchronous Mutations -----
    mutations: {
        /*initialiseStore(state: RootState) {
          if (localStorage.getItem('store')) {
            store.replaceState(
              Object.assign(state, JSON.parse(localStorage.getItem('store')))
            );
          }
        },*/
        user(state, user) {
            state.user = user;
        },
        loading(state, loading) {
            state.loading = loading;
        },
        error(state, error) {
            state.error = error;
        },
        bots(state, bots) {
            console.info('bots updated:', bots);
            state.bots = bots;
        },
        selectBot(state, newBot) {
            console.info('updating state with bot...:', newBot);
            Vue.set(state, 'bot', newBot);
        },
        selectConversation(state, params) {
            if (!params.convId) {
                return;
            }
            console.info('selected conversation:', params);
            for (const convId in state.openConversations) {
                if (convId === params.convId) {
                    // the selected conversation is already open
                    return;
                }
            }
            const selectedConv = state.conversations[params.convId];
            console.info('adding new openConversation');
            Vue.set(state.openConversations, params.convId, { messages: [] });
            if (!selectedConv) {
                Vue.set(state.conversations, params.convId, {
                    botId: params.botId
                    // don't have clientId, so we can't call loadMessages yet.   path:
                });
            }
            else {
                // load messages for conversation
                store.dispatch('loadMessages', params.convId);
            }
        },
        conversation_added(state, conversation) {
            console.info('conversation added:', conversation);
            Vue.set(state.conversations, conversation.id, conversation);
            if (state.openConversations[conversation.id]) {
                store.dispatch('loadMessages', conversation.id);
            }
            // state.bots conversations.push(conversation);
            // state.activeConversations.push(conversation);
            // for (let i = 0; i < state.bots.length; i++) {
            //
            // }
            // console.info('trying to find bot', conversation.bot.ref, 'in', state.bots);
            // conversation.bot.ref
            // state.conversations.push(conversation);
        },
        conversation_modifed(state, conversation) {
            console.info('conversation modified:', conversation);
        },
        conversation_removed(state, conversation) {
            console.info('conversation removed:', conversation);
        },
        messages_loaded(state, { conversationId, messages }) {
            console.info('messages loaded:', conversationId, messages);
            Vue.set(state.openConversations[conversationId], 'messages', messages);
        },
        message_added(state, message) {
            console.info('message added:', message, arguments);
            const openConv = state.openConversations[message.conversationId];
            if (openConv) {
                openConv.messages.push(message);
            }
            // check if conversation already exists
            // const conversation = findConversation(message.data.sessionId, state.conversations);
            // if (!state.conversations[message.conversationId]) {
            //   console.info('conversation not found', message.conversationId);
            //   Vue.set(state.conversations, message.conversationId, {
            //     id: message.conversationId,
            //     messageCount: 1,
            //     bot: state.bots[message.botId],
            //     agents: []
            //     // userName: message.msg
            //   });
            // }
        },
        message_modified(state, message) {
            console.info('message modified:', message);
        },
        message_removed(state, message) {
            console.info('message removed:', message);
        }
        /*request(state, newRequest: RequestFromUser) {
          console.info('updating state with request from user:', newRequest);
    
          state.request = newRequest;
          /!*if (!state.bot || state.bot.id !== newRequest.botId) {
            state.bot = {
              id: newRequest.botId
            };
          }*!/
          /!*state.response = {
            contexts: [],
            fulfillment: {
              messages: []
            }
          };*!/
        }*/
    },
    // ----- Asynchronous Actions -----
    actions: {
        logIn({ commit }, payload) {
            commit('loading', true);
            logIn(payload.email, payload.password)
                .then(firebaseUser => {
                commit('loading', false);
                commit('error', null);
                router.push('/chat');
            })
                .catch(error => {
                commit('error', error.message);
                commit('loading', false);
            });
        },
        logOut() {
            if (unsubscribeFromBotList) {
                unsubscribeFromBotList();
            }
            unsubscribeFromNotifications().then(logOut);
        },
        autoAssignConversation({ commit }, payload) {
            console.info('autoAssignConversation action...');
            commit('selectConversation', payload);
            router.replace({ path: '/chat/' + payload.botId + '/' + payload.convId });
        },
        /*selectConversation({ commit }, payload) {
          commit('selectConversation', payload);
    
          if (!this.$route.params.conversationId) {
            if (this.tabs.length) {
              this.$router.replace({path: this.tabs[0].route});
            } else {
              this.active = null;
            }
          }
        },*/
        loadMessages({ commit, state }, conversationId) {
            const path = state.conversations[conversationId].path.replace(/\/conversations\//, '/messages/');
            loadMessages({ conversationId, path }, payload => {
                commit('messages_loaded', payload);
            }, payload => {
                commit('message_added', payload);
            });
        },
        sendResponse({ commit, state }, response) {
            console.info('need to update the original doc now....', response);
            // debugger;
            const path = state.conversations[response.conversationId].path
                .replace(/\/conversations\/(.*)/, '/messages/$1/' + response.requestId);
            sendResponse(path, response);
            // commit('message_modified', request);
            // commit('message_added', response);
        }
    }
};
export const store = new Vuex.Store(options);
let unsubscribeFromBotList;
// store.subscribe((mutation, state) => {
//   localStorage.setItem('store', JSON.stringify({
//     user: state.user,
//     // openConversations: state.openConversations,
//     // bots: state.bots,
//   }));
// });
onAuthStateChanged(function (user) {
    console.info('user auth state changed.......', user);
    if (user) {
        store.commit('user', {
            id: user.uid,
            email: user.email,
            photoURL: user.photoURL,
            displayName: user.displayName
        });
        subscribeToNotifications();
        console.info('loading bot list...', user.uid);
        unsubscribeFromBotList = loadBotList(user.uid, bots => {
            console.info('..............bots:', bots);
            store.commit('bots', bots);
        }, (type, payload) => {
            store.commit('conversation_' + type, payload);
        }, (type, payload) => {
            store.commit('message_' + type, payload);
        });
    }
    else {
        store.commit('user', null);
    }
});
export default store;
//# sourceMappingURL=store.js.map